import React, { useEffect, useState } from 'react';
import { Container, Table, Row, Col } from 'react-bootstrap';
import classes from './style.module.css'
import League from './League'
import { connect } from "react-redux"
import { GREYHOUND_TABLE_COLUMNS_STATIC, GREYHOUND_TABLE_ALL_STATIC, AVEGAGE_SWITCH } from '../../constants/Constants'
import { SET_SOCCER_LEAGUES_STATE, SET_SELECTION_STATE } from "../../redux/actions"
import sortIconImage from "../../assets/images/sort_both.png"
import { getRaceSummary, getAllRaceDetails, getRaceDetails } from '../../service/backend-api-service';
import Spinner from "../UI/Spinner"
import { Button, ButtonGroup } from 'react-bootstrap'
import "react-sliding-pane/dist/react-sliding-pane.css"
import RaceSlidingPane from "../RaceSlidingPane"
import VolumeMatched from './League/VolumeMatched';
import { useSelector } from 'react-redux';

const LeagueTable = (props) => {
    const [sortOrder, setSortOrder] = useState(true) // true - ascending and false - descending
    const [sortColumn, setSortColumn] = useState(null)
    const [loadingState, setLoadingState] = useState(1)
    const [race, setRace] = useState({})
    const [raceType, setRaceType] = useState(null)
    const [raceSummary, setRaceSummary] = useState(null)

    const staticColumns = []
    for (let value in GREYHOUND_TABLE_COLUMNS_STATIC) staticColumns.push(GREYHOUND_TABLE_COLUMNS_STATIC[value])

    const staticColumnsAll = []
    for (let value in GREYHOUND_TABLE_ALL_STATIC) staticColumnsAll.push(GREYHOUND_TABLE_ALL_STATIC[value])

    const finalColumns = raceType === 'ALL' ? [...staticColumnsAll] : [...staticColumns];



    const sortIconClickedHandler = columnId => {
        setSortColumn(columnId)
        if (sortColumn === columnId) setSortOrder(!sortOrder)
    }

    const averageSwitch = useSelector(state => state.averageSwitch);


    const tableHeaders = finalColumns.map(column => {
        let sortIcon = null
        const description = column.description
        if (!(column.id == GREYHOUND_TABLE_COLUMNS_STATIC.ROW_NUM.id ||
            column.id == GREYHOUND_TABLE_COLUMNS_STATIC.ODD_DETAILS.id ||
            column.id == GREYHOUND_TABLE_COLUMNS_STATIC.WIN_DETAILS.id))
            sortIcon = <img src={sortIconImage} alt="Sort" onClick={() => sortIconClickedHandler(column.id)} />
        if (column.id === GREYHOUND_TABLE_COLUMNS_STATIC.ODD_DETAILS.id) {
            return (
                <th key={column.id}><ButtonGroup size="sm">
                    <Button style={{ backgroundColor: "#74BBEF" }} variant="outline-dark"><b>Back</b></Button>
                    <Button style={{ backgroundColor: "#F8AAB8" }} variant="outline-dark"><b>Lay</b></Button>
                </ButtonGroup>
                </th>
            );
        }else if (column.id === GREYHOUND_TABLE_COLUMNS_STATIC.AVERAGE_RATING.id ||
            column.id === GREYHOUND_TABLE_COLUMNS_STATIC.LENGTH_ADVANTAGE.id) {
            const label = averageSwitch === AVEGAGE_SWITCH.LAST_3.id ? AVEGAGE_SWITCH.LAST_3.label 
            : (averageSwitch === AVEGAGE_SWITCH.LAST_4.id ? AVEGAGE_SWITCH.LAST_4.label : AVEGAGE_SWITCH.LAST_5.label);
            return (
                <th key={column.id}>{`${description}${label}`}</th>
            );
        }
         else {
            return (
                <th key={column.id}>{description}</th>
            );
        }
    })

    useEffect(() => {
        const fetchData = async () => {
            if (race && race != 'undefined') {
                setLoadingState(0)
                let apiData = race.type === 'ALL' ? await getAllRaceDetails(race.date) : await getRaceDetails(race)
                let raceSummary = race.type === 'ALL' ? null : await getRaceSummary(race)
                setRaceSummary(raceSummary);
                props.setSoccerLeaguesState(apiData)
                if (apiData) {
                    setLoadingState(2)
                } else {
                    setLoadingState(1)
                }
            }
        }
        setRaceType(race.type)
        fetchData();

    }, [race])


    useEffect(() => {
        setRace({});
        setLoadingState(1)
        props.setSoccerLeaguesState(null)
    }, [props.selectionState])

    const sortByLengthAdvantage = (a,b) => {
        if(averageSwitch === AVEGAGE_SWITCH.LAST_3.id){
            return a.lengthLast3Advantage - b.lengthLast3Advantage;
        }
        if(averageSwitch === AVEGAGE_SWITCH.LAST_4.id){
            return a.lengthLast4Advantage - b.lengthLast4Advantage;
        }
        return  a.lengthAdvantage - b.lengthAdvantage;
    }

    let itemList
    if (race.type === 'ALL') {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.map((item, index) => {
                return <League key={item.runner + index} date={item.raceDay}
                    finalColumns={finalColumns} type="ALL" item={item} index={index} />
            }) : null
    } else {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.sort(sortByLengthAdvantage).map((item, index) => {
                return <League key={item.runner + index} date={race.raceDay}
                    finalColumns={finalColumns} item={item} index={index} />
            }) : null;
    }

    const volumeMatched = (race.type != 'ALL' && props.soccerLeaguesState && props.soccerLeaguesState.length > 0 &&
        props.soccerLeaguesState[0].bfMarketId) ?
        <VolumeMatched marketId={props.soccerLeaguesState[0].bfMarketId} /> : null

    const header = raceSummary ?
        <>
            <font style={{ fontSize: "1.4em" }}>{raceSummary.title} {' '}{' '}{' '} {volumeMatched}</font>
            <div style={{ display: "none" }} id="fileName">
                {raceSummary.name}_{raceSummary.time}
            </div>       
         </>
        : null;

    let contentBody = null

    if (loadingState === 0) {
        contentBody = <Spinner />
    } else if (loadingState === 1) {
        contentBody = <div style={{ textAlign: "center" }}>Please select race</div>
    } else {
        contentBody =
            <>
                <b>{header} </b>
                <Table className="LeagueTable" id="runnerDetails" triped bordered hover size="sm">
                    <thead>
                        <tr>
                            {tableHeaders}
                        </tr>
                    </thead>
                    <tbody>
                        {itemList}
                    </tbody>
                </Table>
            </>
    }


    return (
        <Container fluid className={classes.LeagueTable}>
            <Row>
                <Col sm={2} style={{ height: "546px", overflowY: "scroll", backgroundColor: "#6c757d" }}>
                    <RaceSlidingPane selectionDate={props.selectionState.selectionDate} raceSelectHandler={setRace} />
                </Col>
                <Col style={{ overflow: "scroll", paddingLeft:"1px" }} > {contentBody}</Col>
            </Row>
        </Container>
    )
}


const mapStateToProps = state => {
    return {
        soccerLeaguesState: state.soccerLeaguesState,
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeagueTable);